import { useCallback } from "react";
import { useSDK } from "@contentful/react-apps-toolkit";
import { getPlanFromCredentials } from "../utils";

export const usePostDeepl = () => {
    const sdk = useSDK();
    const deeplCredentials = sdk.parameters.installation.deeplApiKey;

    const postDeepl = useCallback(
        async (path: string, body: string | null = null, version: "v2" | "v3"): Promise<any> => {
            if (!deeplCredentials) {
                return;
            }

            try {
                const plan = getPlanFromCredentials(deeplCredentials);

                const response = await fetch(`/api/${plan}/${version}/${path}`, {
                    method: "POST",
                    headers: {
                        Authorization: `DeepL-Auth-Key ${deeplCredentials}`,
                        "Content-Type": "application/json",
                        Connection: "keep-alive",
                    },
                    body,
                });

                if (!response.ok) {
                    sdk.notifier.error(`Error using DeepL ${path}.  Status: ${response.status}`);
                }

                return await response.json();
            } catch (error) {
                if (error instanceof Error) {
                    sdk.notifier.error(error.message);
                } else {
                    sdk.notifier.error(`An unknown error has occurred while using DeepL ${path}`);
                }
            }
        },
        [deeplCredentials, sdk.notifier]
    );
    return { postDeepl };
};
